import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = "Village Artisanal - Artisanat Sénégalais de Qualité | FIDAK Soumbédioune",
  description = "Découvrez l'artisanat sénégalais authentique : poterie, vannerie, bijoux, textiles, maroquinerie. Village Artisanal de Soumbédioune - Partenaire FIDAK, soutenu par le Ministère de l'Artisanat du Sénégal.",
  keywords = "village artisanal, artisanat sénégal, FIDAK, Soumbédioune, artisans sénégalais, poterie sénégal, vannerie sénégal, bijoux africains, textile traditionnel, maroquinerie Dakar, ministère artisanat sénégal, art sénégalais, made in senegal, commerce équitable, artisanat africain, Dakar artisanat",
  image = "/images/logo.png",
  url = window.location.href,
  type = "website",
  author = "Village Artisanal Sénégal"
}) => {
  const siteName = "Village Artisanal Sénégal";
  const twitterHandle = "@VillageArtisanalSN";

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="fr_SN" />
      <meta property="og:locale:alternate" content="fr_FR" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      <meta property="twitter:site" content={twitterHandle} />
      <meta property="twitter:creator" content={twitterHandle} />

      {/* Geographic Tags */}
      <meta name="geo.region" content="SN-DK" />
      <meta name="geo.placename" content="Dakar, Sénégal" />
      <meta name="geo.position" content="14.6928;-17.4467" />
      <meta name="ICBM" content="14.6928, -17.4467" />

      {/* Additional SEO Tags */}
      <meta name="language" content="French" />
      <meta name="revisit-after" content="7 days" />
      <meta name="rating" content="general" />
      <meta name="distribution" content="global" />
      <meta name="coverage" content="Worldwide" />
      <meta name="target" content="all" />
      <meta name="HandheldFriendly" content="True" />
      <meta name="MobileOptimized" content="320" />
      
      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Village Artisanal Sénégal",
          "alternateName": ["Village Artisanal de Soumbédioune", "FIDAK Artisanat"],
          "url": "https://villageartisanal.sn",
          "logo": "https://villageartisanal.sn/images/logo.png",
          "description": description,
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Soumbédioune",
            "addressLocality": "Dakar",
            "addressRegion": "Dakar",
            "addressCountry": "SN"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "14.6928",
            "longitude": "-17.4467"
          },
          "sameAs": [
            "https://facebook.com/villageartisanalsenegal",
            "https://instagram.com/villageartisanalsenegal",
            "https://twitter.com/VillageArtisanalSN"
          ],
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer service",
            "areaServed": "SN",
            "availableLanguage": ["French", "Wolof"]
          }
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
